

const permissions = {

  "users": ["user_list", "user_create", "user_edit", "user_activate", "role_assign"],
  "roles": ["role_list", "role_create", "role_edit", "role_delete"],
  "machines": ["machine_list", "machine_create", "machine_edit", "machine_delete"],
  "devices": ["device_list", "device_create", "device_edit", "device_delete"],
  "production_lines": ["production_line_list", "production_line_create", "production_line_edit", "production_line_delete"],
  "product_lines": ["product_line_list", "product_line_create", "product_line_edit", "product_line_delete"],
  "product_arrays": [
    "ctr_report",
    "ctr_run",
    "irl_report",
    "irl_run",
    "oee_report",
    "oee_run",
    "consumption_history_import",
    "balance_master_import",
    "ep_master_import",
    "finished_product_master_import",
    "material_master_import",
    "oc_master_import",
    "order_master_import",
    "unit_value_import",
    "consumption_history_finished_product_import",
    "op_master_import",
    "vn_pt_uh_import",
  ],
  "parameters": ['parameter_list', "parameter_edit"],
}

export default permissions;


